import digitalData from 'digital-data';
import { getState, setState } from '../../../analytics-state';
import {
  PEP,
  PAGE_AB_TEST,
  BROWSE,
  PRODUCTS_AVAILABILITY,
  PLP_GRID,
  NUCLEUS,
  NO_EVENT,
  PAGINATION,
  FILTER,
  SORT,
  ONLINE_STORE
} from '../../../constants';
import {
  getContentProducts,
  setAnalytics,
  getProductAnalytics,
  getCategoryBreadCrumbs,
  getCurrentPage,
  shouldReInitAnalytics,
  getFilters,
  getDomainList
} from '../../../thd-analytics-utils';

export function pep() {

  const { take } = LIFE_CYCLE_EVENT_BUS.effects;
  let cachedPepModel;
  let cachedProduct;

  const initPEP = (productPromise, browsePromise) => {
    Promise.all([productPromise, browsePromise]).then((dataList) => {

      if (dataList?.length < 2) return;
      const assignedData = dataList.reduce((acc, data, index) => {
        const newAcc = acc;
        newAcc[data?.__typename || index] = data;
        return newAcc;
      }, {});

      const { BaseProduct: product, SearchModel: pepModel } = assignedData;
      const { breadCrumbs = [] } = product?.taxonomy || {};
      const { products, searchReport, metadata } = pepModel || {};

      const {
        startIndex,
        pageSize,
        sortOrder,
        sortBy
      } = searchReport || {};

      const { pageType = '', pageTransitionEvent = NO_EVENT } = getState() || {};

      if (products?.length) {
        digitalData.content = {
          ...digitalData.content,
          product: getContentProducts(products, pageType) || [],
          feature: {
            plpModule: products?.length ? 'y' : 'n'
          }
        };
      }

      setState({
        ...getState(),
        pageTransitionEvent: undefined
      });

      if (!shouldReInitAnalytics(pageTransitionEvent)) {
        if (pageTransitionEvent === FILTER) {
          LIFE_CYCLE_EVENT_BUS.trigger('filters-refinements.publish', {
            breadCrumbs: pepModel?.taxonomy?.breadCrumbs,
            searchReport,
            metadata
          });
        } else if (pageTransitionEvent === SORT) {
          LIFE_CYCLE_EVENT_BUS.trigger('sort-refinements.publish');
        }
        return;
      }

      digitalData.page = {
        pageInfo: {
          pageName: 'product entry page>' + product?.identifiers?.itemId,
          pageLoadEvent: pageTransitionEvent === PAGINATION ? PAGINATION : 'pep view',
          pageType: PEP,
          platform: NUCLEUS,
          abTest: PAGE_AB_TEST
        },
        category: getCategoryBreadCrumbs(breadCrumbs) || {},
        displayAttributes: {
          pageNumber: getCurrentPage(startIndex, pageSize),
          productsAvailability: PRODUCTS_AVAILABILITY,
          sortBy,
          viewType: PLP_GRID
        },
        filter: getFilters({ appliedDimensions: pepModel?.appliedDimensions })
      };

      // let serviceAddons; // Todo: Kalee killed the service addons, will fix it
      // if (info.hasServiceAddOns) {
      //   serviceAddons = yield selectState('dataSources.serviceAddons', { timeout: 3000 });
      // }

      digitalData.product = getProductAnalytics({
        product
      });

      digitalData.event = digitalData.event || [];

      setAnalytics(digitalData);
    });
  };

  const browsePromise = ({ skipBrowse = false } = {}) => {
    if (skipBrowse) return new Promise((res) => res(cachedPepModel));
    return new Promise((resolve) => {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.off('pep.new-products');
      LIFE_CYCLE_EVENT_BUS.lifeCycle.on('pep.new-products', ({ output: browseModel }) => {
        resolve(browseModel);
        cachedPepModel = browseModel;
      });
    });
  };

  const productPromise = ({ skipProduct = false } = {}) => {
    if (skipProduct) return new Promise((res) => res(cachedProduct));
    let hasInitedProduct = false;
    return new Promise((resolve) => {

      LIFE_CYCLE_EVENT_BUS.on('thd-analytics.state-change', ({ output = {} }) => {
        if (hasInitedProduct) { return; }

        const {
          experienceName,
          storeId,
          dataSources,
          pageItemId,
          pageType
        } = output;
        if (pageType !== 'pep') { return; }

        const product = dataSources?.product?.[pageItemId] || {};
        const domains = getDomainList(experienceName);
        let keys = Object.keys(product);
        if (product) {
          keys = keys.concat(Object.keys(product) || {});
        }
        keys = keys.filter((key) => key !== '__typename');
        const hasDomains = domains.every((domain) => keys.indexOf(domain) > -1);
        if (hasDomains && storeId !== ONLINE_STORE && product?.__typename === 'BaseProduct') {
          hasInitedProduct = true;
          resolve(product);
          cachedProduct = product;
        }
      });
    });
  };

  initPEP(productPromise(), browsePromise());

  const onEventClick = ({ skipProduct = false, skipBrowse = false } = {}) => {
    initPEP(productPromise({ skipProduct }), browsePromise({ skipBrowse }));
  };

  window.LIFE_CYCLE_EVENT_BUS.on('pagination.click', () => {
    onEventClick({ skipProduct: true });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('filters-refinements.click', () => {
    onEventClick({ skipProduct: true });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('sort-refinements.click', () => {
    onEventClick({ skipProduct: true });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('super-sku.click-swatch', () => {
    onEventClick({ skipBrowse: true });
  });
}
